<template>
    <div class="text-center">
      <v-dialog persistent v-if="visible" v-model="visible" width="800">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-pencil</v-icon>
              {{ edit ? "Editar" : "Cadastrar" }} Turma
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-form ref="form">
              <v-row class="d-flex justify-center mt-7">
                <v-col cols="12">
                    <v-text-field
                    label="Nome da Turma*"
                    v-model="content.nome"
                    outlined
                    dense
                    maxlength="25"
                    :rules="[(v) => $required(v)]"
                    ></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.anoLetivo"
                    label="Ano Letivo*"
                    item-text="ano"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listAnosLetivos"
                    :rules="[(v) => $required(v)]"
                    ></v-select>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.serie"
                    label="Ano/Serie*"
                    item-text="nome"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listAnoSeries"
                    :rules="[(v) => $required(v)]"
                    ></v-select>
                </v-col>
                <v-col cols="4">
                    <v-select
                    v-model="content.turno"
                    label="Turno*"
                    item-text="descricao"
                    item-value="id"
                    outlined
                    dense
                    :items="lists.listTurnos"
                    :rules="[(v) => $required(v)]"
                    ></v-select>
                </v-col>
                <v-col cols="6">
                <v-autocomplete
                  v-model="content.municipio"
                  label="Município*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  return-object
                  dense
                  :items="lists.listMunicipios"
                  @change="filterEscolasByMunicipios"
                  :rules="[(v) => $required(v)]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="content.escola"
                  label="Escola*"
                  item-text="local"
                  item-value="id"
                  outlined
                  dense
                  return-object
                  @change="filterProfessoresByEscola"
                  :items="form.lists.listEscolasFilter"
                  :rules="[(v) => $required(v)]"
                ></v-autocomplete>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.professorPortugues"
                  label="Professor(a) de Língua Portuguesa*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="form.lists.listsProfessorFilter"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
              <v-col cols="6">
                <v-select
                  v-model="content.professorMatematica"
                  label="Professor(a) de Matemática*"
                  item-text="nome"
                  item-value="id"
                  outlined
                  dense
                  :items="form.lists.listsProfessorFilter"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>

            <v-col cols="4">
                <v-text-field
                label="Quantidade de Alunos*"
                v-model="content.quantidadeAlunos"
                outlined
                dense
                v-only-number
                maxlength="2"
                :rules="[(v) => $required(v)]"
                ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <div class="mt-4">
              <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
              <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
            </div>
          </div>
          <sca-buttons
            @click="salvar()"
            @cancel="$emit('onClose')"
            :actionText="edit ? 'Editar' : 'Salvar'"
          ></sca-buttons>
        </v-card>
      </v-dialog>
    </div>
  </template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Turma } from '~/commons/classes/turma';
import TurmaService from '~/services/turma.service';

export default {
  props: {
  ...new DialogProps(Turma),
  lists: {
    type: Object,
  },
  },
  mixins: [TurmaService,],
  data: () => ({
    form: {
      lists: {
        listEscolasFilter: [],
        listsProfessorFilter:[]
      },
    },
  }),
  watch: {
  visible(newVal) {
    if (newVal) {
      this.updateFilters();
    }
  },
  },
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const turma = new Turma(this.content).format();
          return this.edit
            ? this.$editarTurma(turma, turma.id)
            : this.$cadastrarTurma(turma);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    filterEscolasByMunicipios() {
      this.content.escola = null;
      this.content.professorPortugues = null;
      this.content.professorMatematica = null;
      this.form.lists.listEscolasFilter = this.lists.listEscolas.filter(escola => escola.municipio === this.content.municipio.nome);
    },
    filterProfessoresByEscola() {
      this.content.professorPortugues = null;
      this.content.professorMatematica = null;
      this.form.lists.listsProfessorFilter = this.lists.listProfessor.filter(prof => prof.lotacao === this.content.escola.local);
    },
    updateFilters() {
      if(this.edit){
        const municipo = this.lists.listMunicipios.find(mun => mun.id === this.content.municipio);
        const escola = this.lists.listEscolas.find(escola => escola.id === this.content.escola);
        this.form.lists.listEscolasFilter = this.lists.listEscolas.filter(escola => escola.municipio === municipo.nome);
        this.form.lists.listsProfessorFilter = this.lists.listProfessor.filter(prof => prof.lotacao === escola.local);
      }
    },
  },
};
</script>
